export default __webpack_public_path__ + "/dist/images/dummy-profile-pic.cb61008f624480728706bc9e3aedd0f7.jpg";